module.exports = __webpack_public_path__ + "static/media/logo-thatsit.f097093f.svg";